import { render } from "./Torihikiuriagecreate.vue?vue&type=template&id=2d2b02a4&ts=true"
import script from "./Torihikiuriagecreate.vue?vue&type=script&lang=ts"
export * from "./Torihikiuriagecreate.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__